import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextEditor from '../../shared/TextEditor';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
  },
  {
    name: 'RoleDescription',
  },
);

const RoleDescription = ({
  isChecked,
  onSwitchChange,
  value,
  onChange,
  isSaved,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:advanceSettingContainer.botRole`)}
        tooltip={t(`${pathKey}:advanceSettingContainer.botRoleTooltip`)}
        isChecked={isChecked}
        onSwitchChange={onSwitchChange}
        isEnableSwitch
        disabled={disabled}
      />
      {isChecked && (
        <TextEditor
          contentClassName={classes.textEditor}
          onChange={v => onChange(v)}
          origriData={value}
          placeholder={t(
            `${pathKey}:advanceSettingContainer.botRolePlaceholder`,
          )}
          maxLength={120}
          isError={isSaved && !value}
          style={{ width: 601 }}
          disabled={disabled}
          isShowEmoji={false}
          isShowCustomerName={false}
        />
      )}
    </div>
  );
};

export default RoleDescription;
